/*
 * @Author: kangkang 1278279046@qq.com
 * @Date: 2022-05-11 09:21:46
 * @LastEditors: 付康 fukang@yuouhui.com
 * @LastEditTime: 2022-11-03 10:48:10
 * @FilePath: \experience-pc\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUi from 'element-ui'
import Vant from 'vant';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import axios from 'axios'
import store from './store';
import '@/icons/index.js'
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import VueQuillEditor from 'vue-quill-editor'
import Util from './util/util.js';
import cache from './util/cache.js'
import '../static/skins/content/default/content.css'
import { getToken } from "@/util/cookie";
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import VueClipboard from 'vue-clipboard2'
import Carousel3d from 'vue-carousel-3d'
import 'vant/lib/index.css';






Vue.config.productionTip = true;

Vue.use(ElementUi);
Vue.use(VueQuillEditor);
Vue.use(preview)
Vue.use(VueClipboard)
Vue.use(Carousel3d);
Vue.use(Vant);
Vue.prototype.$cache = cache

//修改axios原型链


axios.interceptors.request.use(config => {
    if (config.push === '/index') {
        // 不需要校验token
    } else {
        if (getToken()) {
            //{'Authorization': token}
            config.headers.Authorization = getToken();
        }
    }
    return config;
}, error => {
    return Promise.reject(error);
});

Vue.prototype.Axios = axios;
Vue.prototype.Axios.defaults.baseURL = process.env.BASE_URL;
Vue.prototype.imgUrl = process.env.BASE_URL;

Vue.directive('loadmore', {
    bind(el, binding) {
        const selectWrap = el.querySelector('.el-table__body-wrapper')
        selectWrap.addEventListener('scroll', function() {
            let sign = 0
            const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight
            if (scrollDistance <= sign) {
                binding.value()
            }
        })
    }
})

router.beforeEach((to, from, next) => {
        // if (to.meta.requireAuth) { //判断该路由是否需要登录
        //   if (store.getters.getToken) {
        //     next();
        //   } else {
        //     Util.Message('error', '发生错误，请重新登录');
        //     next({
        //       path: '/',
        //       query: { redirect: to.fullPath } //将跳转的路由path作为参数，登录成功后跳转该路由
        //     })
        //   }
        // } else if(to.matched.length == 0) { 
        //   // 匹配不到页面到登录
        //   next({path: '/404/'});
        // } else {
        next()
            // }
    })
    /* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {
        App
    }
})


// WEBPACK FOOTER //
// ./src/main.js